var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBluenote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 467.92 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M451.65,26.14v803.4s-329.81,76.77-303.91,478.81c0,0-130.49,165.81-130.49,165.81v-486.26c0-116.96,0-233.93,0-350.89,0-119.56-10.23-232.97,35.94-345.37,42.05-102.36,119.12-186.05,222.1-228.81,26.36-10.94,53.79-19.19,81.7-25.09,8.17-1.73,94.67-13.94,94.67-11.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBluenote);
export default __webpack_public_path__ + "static/media/logo_bluenote.4655b6e200d725d10b767063d5dd84da.svg";
export { ForwardRef as ReactComponent };